module.exports = __webpack_public_path__ + "static/img/download-guide.26b73e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download-guide.png
// module id = zrCD
// module chunks = 1